import { useEffect, useState } from "react";
import { api, fmtEUR } from "@/lib/api";
import { BarChart3, Banknote, CreditCard, FileText, TrendingUp } from "lucide-react";

export default function PosReport() {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/pos/my-report?date=${date}`).then(r => setData(r.data)).finally(() => setLoading(false));
  }, [date]);

  const stats = data ? [
    { label: "Shitje totale", value: fmtEUR(data.total), color: "text-[#FFD600]", icon: TrendingUp },
    { label: "Kesh", value: fmtEUR(data.cash), color: "text-emerald-400", icon: Banknote },
    { label: "Kartë", value: fmtEUR(data.card), color: "text-blue-400", icon: CreditCard },
    { label: "Fatura firme", value: fmtEUR(data.invoice), color: "text-[#FFD600]", icon: FileText },
  ] : [];

  return (
    <div className="p-3 sm:p-4 lg:p-6">
      <div className="flex items-center gap-3 mb-4">
        <BarChart3 size={26} className="text-[#FFD600]" />
        <h1 className="font-display text-2xl sm:text-3xl uppercase">Raport ditor</h1>
        <input type="date" value={date} onChange={e => setDate(e.target.value)} data-testid="report-date"
          className="ml-auto bg-black border border-[#262626] px-3 py-2 text-sm focus:border-[#FFD600] outline-none" />
      </div>

      {loading ? (
        <div className="text-center py-10 text-neutral-400">Duke ngarkuar...</div>
      ) : !data ? (
        <div className="text-center py-10 text-neutral-500">Nuk ka të dhëna</div>
      ) : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
            {stats.map(s => {
              const Icon = s.icon;
              return (
                <div key={s.label} className="hg-card p-4" data-testid={`report-${s.label.toLowerCase().replace(/\s/g,'-')}`}>
                  <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-400 mb-2">
                    <Icon size={14} /> {s.label}
                  </div>
                  <div className={`text-2xl font-bold ${s.color}`}>{s.value}</div>
                </div>
              );
            })}
          </div>

          <div className="grid md:grid-cols-2 gap-3 mb-4">
            <div className="hg-card p-4">
              <div className="text-xs uppercase tracking-widest text-neutral-400 mb-1">Numri i shitjeve</div>
              <div className="text-3xl font-bold">{data.count}</div>
            </div>
            <div className="hg-card p-4">
              <div className="text-xs uppercase tracking-widest text-neutral-400 mb-1">TVSH e mbledhur</div>
              <div className="text-3xl font-bold">{fmtEUR(data.vat)}</div>
            </div>
          </div>

          <div className="hg-card p-4">
            <div className="font-bold text-lg mb-3">Produktet e shitura</div>
            {data.products_sold.length === 0 ? (
              <div className="text-center py-6 text-neutral-500 text-sm">Ende s'ka shitje për këtë ditë</div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="text-xs uppercase text-neutral-400 border-b border-[#262626]">
                    <tr>
                      <th className="text-left py-2 pr-3">Produkti</th>
                      <th className="text-right py-2 pr-3">Sasia</th>
                      <th className="text-right py-2">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.products_sold.map(p => (
                      <tr key={p.product_id} className="border-b border-[#262626]/50" data-testid={`report-prod-${p.product_id}`}>
                        <td className="py-2 pr-3">{p.name}</td>
                        <td className="py-2 pr-3 text-right">{p.qty}</td>
                        <td className="py-2 text-right font-bold">{fmtEUR(p.total)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
